import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import HospitalizationDialog, {
  HospitalizationDialogCallbackInput,
  HospitalizationDialogInterfaceProps,
} from '../HospitalizationsDialog';

const { useDialogForContext, useDialog: useHospitalizationDialog } =
  getDialogHooks<
    HospitalizationDialogInterfaceProps,
    HospitalizationDialogCallbackInput
  >(HospitalizationDialog);
export const useHospitalizationDialogForContext = useDialogForContext;
export default useHospitalizationDialog;
